import React from 'react';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import TeamHeader from '../components/team/TeamHeader';
import TeamLevels from '../components/team/TeamLevels';

const Team = () => {
  const { account } = useWallet();
  const user = useUserData();

  return (
    <Layout dashboard>
      <div className="page-header">
        <div className="page-title">Team</div>
        <div className="page-subtitle">Your upline, direct referrals, and matrix downline by package.</div>
      </div>

      {!account || !user.userId ? (
        <div className="card" style={{ textAlign: 'center' }}>
          <div className="empty-title">Connect & register to view your team</div>
        </div>
      ) : (
        <>
          <TeamHeader userId={user.userId} sponsorId={user.core?.sponsorId} />
          <TeamLevels userId={user.userId} />
        </>
      )}
    </Layout>
  );
};

export default Team;
